import { render, staticRenderFns } from "./IntegratorInnCashCredentialsConfigTab.vue?vue&type=template&id=3163ec68"
import script from "./IntegratorInnCashCredentialsConfigTab.vue?vue&type=script&lang=ts"
export * from "./IntegratorInnCashCredentialsConfigTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports